import { Provider } from '@angular/core';
import { HttpAuthenticationService as Value } from '@daas-consulting/security/authentication/frontend/data_access';
import { AuthenticationServiceId as Provide } from '@daas-consulting/security/authentication/frontend/data_contracts';

export const HttpAuthenticationServiceProvider: Provider = {
  provide: Provide,
  useClass: Value,
};
